module.exports = __webpack_public_path__ + "img/bronze.4e2ddcc1.png";